module.exports = __webpack_public_path__ + "roboto-thinitalic-webfont.5a7d3c07fce0fdb65279.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-thinitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-thinitalic-webfont.woff
// module chunks = styles